export enum OrdemCargaPageTypes {
  'LOAD_REQUEST' = '@OrdemCargaPage/LOAD_REQUEST',
  'LOAD_SUCCESS' = '@OrdemCargaPage/LOAD_SUCCESS',
  'LOAD_FAILURE' = '@OrdemCargaPage/LOAD_FAILURE',

  'FILTER_ORDEMCARGAPAGE' = '@estoque/FILTER_ORDEMCARGAPAGE',

  'SORTER_ORDEMCARGAPAGE' = '@estoque/SORTER_ORDEMCARGAPAGE',

  'CLEAN_ORDEMCARGAPAGE' = '@OrdemCargaPage/CLEAN_ORDEMCARGAPAGE',
}

export interface Pagination {
  total: number;
  pageSize: number;
  current: number;
  showSizeChanger: boolean;
  pageSizeOptions: string[];
}

export interface IOrdemCargaPage {
  codEmp: number;
  codCdd: number;
  nomeCdd: string;
  ordemCarga: number;
  tipoWms: string;
  placa: string;
  cpfMotorista: string;
  motorista: string;
  status: string;
  pesoTotal: number;
  vlrTotal: number;
  transportadora: string;
  destinatario: string;
  agendavel: boolean;
  tipVei: string;
  codMotorista: number;
  codVeiculo: number;
  codDestinatario: number;
  clienteRetira: boolean;
  tipoCarga: string;
  assoalho: string;
  codTransportadora: number;
  codTipVeiculo: number;
  pedidos: Pedidos[];
}

export interface Pedidos {
  nuNota: number;
  numNota: number;
  codFornecedor: number;
  codDestinatario: number;
  pesoBruto: number;
  valor: number;
  destinatario: string;
  fornecedor: string;
  observacao: string;
  cidadeOrigem: string;
  qtdVolume: number;
  tipoVolume: string;
  nunotaEmitida: number;
  produto: string;
  nomeCD: string;
  temAnexo: number;
}

export interface IFiltroOrdemCarga {
  ordemCarga: number;
  codTipoVeiculo: string;
  codTransportadora: number;
  tipoWms: string;
}

export interface OrdemCargaPageState {
  readonly data?: IOrdemCargaPage[];
  readonly loading: boolean;
  readonly error: boolean;
  readonly filter?: IFiltroOrdemCarga | undefined;
  readonly pagination: Pagination;
  readonly sorter?: any;
}
